import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Project } from '../types/content';
export function WorkCard({
  project,
  large = false
}: {
  project: Project;
  large?: boolean;
}) {
  return <Link to={`/work/${project.slug}`} className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-4 focus-visible:ring-offset-ivory" data-id="element-156" data-mp="jf4no0cc8ydt">
      <div className={`relative overflow-hidden rounded-[1.75rem] border border-charcoal/[0.07] bg-ivorydeep ${large ? 'aspect-[16/10]' : 'aspect-[4/3]'}`} data-id="element-157" data-mp="akzqkz6m2qpu">
        <img src={project.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.6s] ease-editorial group-hover:scale-[1.05]" data-id="element-158" data-mp="qptx5amz69b" />
        <div className="absolute inset-0 bg-charcoal/0 transition-colors duration-700 group-hover:bg-charcoal/[0.08]" data-id="element-159" data-mp="3rv6hg86pfh6l" />
      </div>
      <div className="mt-6 flex items-start justify-between gap-6" data-id="element-160" data-mp="38pvqqbrsj70q">
        <div data-id="element-161" data-mp="33rluryy8s2e2">
          <p className="eyebrow text-mocha" data-id="element-162" data-mp="33ru4jhz2irl1">{project.category}</p>
          <h3 className={`mt-3 max-w-xl font-serif font-light leading-[1.1] tracking-[-0.01em] text-charcoal ${large ? 'text-[2rem] sm:text-[2.75rem]' : 'text-[1.5rem] sm:text-[1.875rem]'}`} data-id="element-163" data-mp="33togi6sd39cz">
            {project.title}
          </h3>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-charcoal/55" data-id="element-164" data-mp="2q0gqgjjxilxe">
            {project.excerpt}
          </p>
        </div>
        <ArrowUpRightIcon className="mt-1 h-5 w-5 shrink-0 text-charcoal/40 transition-all duration-500 ease-editorial group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-charcoal" strokeWidth={1.2} data-id="element-165" data-mp="2zpqi5yav22kz" />
      </div>
    </Link>;
}